import { BreakerQuestionDTO } from 'jobs/dtos/questions'
import { QuestionInputValue } from '../input-value-types'
import QuestionViewModelBase from '../QuestionViewModelBase'

export default class BreakerQuestionViewModel extends QuestionViewModelBase<BreakerQuestionDTO> {
  get isAnswered(): boolean {
    return true
  }

  answer: unknown

  protected textAnswer(): string {
    return ''
  }

  protected hydrateAnswer(): void {
    /* */
  }

  protected serializeAnswer() {
    return undefined
  }

  toInputValue(): QuestionInputValue {
    return { type: 'BREAKER', value: '' }
  }
}
